/* import __COLOCATED_TEMPLATE__ from './tag-filter.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type KnowledgeHubService from 'embercom/services/knowledge-hub-service';
import type Tag from 'embercom/models/tag';
import type IntlService from 'ember-intl/services/intl';
import { type TagOperator } from 'embercom/lib/knowledge-hub/constants';
import { IN_OPERATOR } from 'embercom/lib/outbound/constants';

interface Args {
  activeFilter?: string;
  doSearch: (key?: string, tagIds?: string[]) => void;
  removeFilter: () => void;
  selectedTagValues?: string[];
  tagOperator?: TagOperator;
  setTagOperator?: (tagOperator?: TagOperator) => void;
}

export default class TagFilter extends Component<Args> {
  @service declare appService: AppService;
  @service declare intl: IntlService;
  @service declare knowledgeHubService: KnowledgeHubService;

  get isOpen() {
    return this.args.activeFilter === 'tag' && !this.args.selectedTagValues?.length;
  }

  get tagOperator(): TagOperator {
    return this.args.tagOperator ?? IN_OPERATOR;
  }

  set tagOperator(value: TagOperator) {
    this.args.setTagOperator?.(value);
  }

  get tags() {
    return this.appService.app.tags
      .reject((tag: Tag) => tag.archived)
      .sort((a: Tag, b: Tag) => a.name.localeCompare(b.name));
  }

  get emptyTagsEntry() {
    return { text: this.intl.t('articles.list.no_tags'), value: 0 };
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Filters::TagFilter': typeof TagFilter;
    'knowledge-hub/filterable-list/filters/tag-filter': typeof TagFilter;
  }
}
